import React, { act, useEffect, useState } from "react";

import styled from "styled-components";
import FormTitle from "../../organisms/FormTitle";
import FormTable from "../../organisms/FormTable";
import useDeviceSize from "../../../hooks/useDeviceSize";
import mixins, { media } from "../../../styles/mixins";
import Button from "../../atoms/Button";
import Modal from "../../organisms/Modal";
import Form, { ErrorMsg } from "../../atoms/Form";
import SelectOption from "../../molecules/SelectOption";
import Caption from "../../atoms/Caption";
import { useDispatch, useSelector } from "react-redux";
import { hideConfirm, showConfirm } from "../../../reducer/confirmSlice";
import { showAlert } from "../../../reducer/alertSlice";
import { useActivityTransferCheckAbo, useOwnedActivity, useTransferActivity, useTransferredActivityDecision, useTransferredActivityList, useTransferHistory } from "../../../hooks/api/useActivityTransfer";
import { maskingUserInfo } from "../../../utils/utils";
import { Controller, useForm } from "react-hook-form";

const Wrap = styled.div`
	.table-title {
		font-size: 24px;
		font-weight: 600;
		margin-top: 30px;
		color: #000;

		${media.mobile`
			padding: 0 10px;
			font-size: 18px;
		`}
	}
	.form-table {
		td {
			color: #000;
			strong {
				font-weight: 600;
			}
		}
	}

	.notice {
		margin-top: 40px;
		li {
			list-style: "* ";
			${mixins.fontStyle("18px", 400, 1.4)}
			color: rgba(0, 0, 0, 0.4);
			word-break: keep-all;
		}
	}

	/* 양도/양수 내역 테이블 */
	.transfer-history-table {
		thead tr {
			border-top: 3px solid #000;
			border-bottom: 1px solid #ADADAD;
		}
		thead th::after {
			display: none !important;
		}
		th {
			padding: 17px 0 !important;
			font-size: 18px;
			font-style: normal;
			font-weight: 600;
		}
		th, td {
			border-color: #adadad !important;
		}
		.col-count {
			width: 150px;
		}
		.col-date {
			width: 260px;
			padding-left: 20px;
			padding-right: 20px;
		}

		${media.mobile`
			padding-top: 24px;

			table {
				border-top: 2px solid #000;
			}
			tr {

			}
			th {
			    width: 166px;
			    padding: 23px 20px !important;
				font-size: 14px;
			}
			td {
				color: #858585;
			}

			.status-row {
				border-bottom: 10px solid #E8E8E8;
			}
		`}
	}

	.empty-history {
		padding: 60px 0;
		text-align: center;
		${mixins.fontStyle("18px", 400, 1.4)}
		color: rgba(0, 0, 0, 0.4);

		${media.mobile`
			padding: 40px 20px;
			${mixins.fontStyle("14px", 400, 1.4)}
		`}
	}

	> .btn-wrap {
		display: flex;
		gap: 20px 40px;
		margin-top: 140px;
		margin-bottom: 123px;

		${media.mobile`
			margin-bottom: 63px;
		`}

		button {
			position: relative;
		}
	}

	/* 양도하기 모달 */
	.activity-transfer-modal {
		.modal-container {
			width: 777px;
			min-width: 777px;
			height: 792px;
		}

		.form-table:first-of-type {
			padding-top: 0;
		}

		.form-table td {
			color: #000;
		}

		.abo-input-wrap {
			display: flex;
			gap: 10px;

			.form-group {
				flex-grow: 1;
			}

			.btn-check-abo {
				height: 52px;
				width: 195px;
				border-radius: 4px;
				font-size: 18px;
				font-weight: 400;

				&:disabled {
					background-color: #f3f3f3;
					border-color: #f3f3f3;
					color: #858585;
				}
			}
		}

		.btn-wrap {
			display: flex;
			gap: 20px;
			margin-top: 80px;

			.btn-transfer {
				&:disabled {
					background-color: #f3f3f3;
					border-color: #f3f3f3;
					color: #858585;
				}
			}
		}
	}

	/* 양도받기 모달 */
	.activity-transferred-modal {
		.btn-reject,
		.btn-accept {
			display: inline-flex;
			height: 50px;
			width: 146px;
			font-size: 18px;
		}

		td {
			padding-right: 0;
		}

		.caption {
			&::before {
				content: "*";
			}
			margin-top: 18px;
			display: flex;
			gap: 5px;
			word-break: keep-all;
		}
	}

	/* mo */
	${media.mobile`
        .form-table.transfer-table-wrap {
            padding-top: 0px;

			> table {

				> tbody {
					> tr {
						thead {
							th {
								padding-bottom: 20px;
							}
						}

						&:not(:last-of-type) {
							tr {
								&:last-of-type {
									th, td {
										border-bottom: none;
									}
								}
							}
						}

						> td, > th {
							border: none;
						}
						
						.mo-form-table-wrap {
							.form-table {
								padding-top: 0;

								table {
								    margin: 24px 0;

									thead {
										th {
											padding: 0;
										}
									}

									tbody {
										th {
											width: auto;
										}
										tr {
											&:last-child {
												th {
													padding: 23px 6px 23px 20px;
												}
											}
										
											td {
												padding: 10px 20px;
											}
										}
									}
								}
							}
						}

						& ~ tr {
							.mo-form-table-wrap {
								&::before {
									content: "";
									display: block;
									height: 10px;
									background-color: #e8e8e8;
								}
							}
						}

						td {
							color: #858585;
						}
					}
				}
			}
        }

        .notice {
			margin-top: 0;
			padding: 10px 20px 10px 30px;

            li {
                font-size: 12px;
            }
        }

        > .btn-wrap {
            flex-direction: column;
            margin-top: 70px;
        }

        /* 양도하기 모달 */
        .activity-transfer-modal {
            .modal-container {
                width: 100%;
				height: 100%;
				min-width: unset;
				min-height: unset;
				position: relative;
				top: unset;
				left: unset;
				transform: unset;

				.modal-body {
					padding: 0;
				}
            }

			.form-table.transfer-table-wrap {
				> table {
					> tbody {
						> tr {
							table {
								margin: 0 !important;

								td {
								    padding: 10px 20px 10px 0 !important;
								}
							}

							thead {
								th {
									font-size: 16px;
									font-weight: 600;
									line-height: 21.8px;
									letter-spacing: 0;
									padding: 14px 20px !important;
								}
							}
						}
					}
				}	
			}

            .abo-input-wrap {
                flex-direction: column;
                gap: 14px;

                .form-group {
                    > p {
                        margin-top: 5px !important;
                    }
                }

                .btn-check-abo {
					width: 100%;
                    height: 40px;
					font-size: 14px;
                }
            }

            .btn-wrap {
				margin-top: 20px;
				gap: 10px;
				padding: 0 20px 20px;

				button:first-child {
					width: 70px;
				}
            }
        }

        /* 양도받기 모달 */
        .activity-transferred-modal {
		    .modal-container {
                width: 100%;
				height: 100%;
				min-width: unset;
				min-height: unset;
				position: relative;
				top: unset;
				left: unset;
				transform: unset;

				.modal-body {
					padding: 0px 0px 20px;
				}
            }

			.form-table.transfer-table-wrap {
				> table {
					> tbody {
						> tr {
							table {
								margin: 0 !important;
							}

							thead {
								th {
									font-size: 16px;
									font-weight: 600;
									line-height: 21.8px;
									letter-spacing: 0;
									padding: 14px 20px !important;
								}
							}
						}
					}
				}	
			}

            .form-table {
                &:first-of-type {
                    padding-top: 0;
                }

                td {
                    &.activity-info {
                        padding: 0 !important;
    
                        li {
                            display: flex;
                            .title {
                                display: flex;
                                align-items: center;
                                width: 40%;
                                padding: 23px 20px;
                                ${mixins.fontStyle("14px", 600, 1.2)}
								color: #000;
                            }
    
                            .value {
                                display: flex;
                                align-items: center;
                                flex-grow: 1;
                                padding: 10px 20px;
                            }

                            & ~ li {
                                .title, .value {
                                    padding-top: 0;
                                    padding-bottom: 20px;
                                }
                            }
                        }
                    }

                    .btn-wrap {
                        display: flex;
                        gap: 10px;
						margin: 10px 0;

						button {
							font-size: 14px;
						}
                    }
                }
            }

            .caption {
                font-size: 12px;
                margin-top: 20px;
                padding: 0 20px;
            }
        }
    `}
`;



const ActivityTransfer = ({ scheduleIdx, urlPath }) => {
	const customersInfo = useSelector((state) => state.customers).value;
	const primaryCustomer = customersInfo.filter((v) => v.isPrimary)[0];

	const dispatch = useDispatch();
	const { isMobile } = useDeviceSize();


	const [showActivityTransferModal, setShowActivityTransferModal] = useState(false); // 액티비티 양도하기 모달
	const [showActivityTransferredModal, setShowActivityTransferredModal] = useState(false); // 액티비티 양도받기 모달
	const [checkAbo, setCheckAbo] = useState(); // 양도할 ABO 확인 input
	const [isCheckedAbo, setIsCheckedAbo] = useState({
		status: false,
		msg: "",
	});

	const activityTransferCheckAbo = useActivityTransferCheckAbo({ eventScheduleIdx: scheduleIdx, toAbo: checkAbo, fromAbo: primaryCustomer?.uid }); // 양도할 ABO 인증
	const ownedActivityQuery = useOwnedActivity(scheduleIdx, primaryCustomer?.uid); // 보유한 액티비티 조회
	const transferredActivityListQuery = useTransferredActivityList(scheduleIdx, primaryCustomer?.uid); // 양도받은 액티비티
	const transferHistoryQuery = useTransferHistory(scheduleIdx, primaryCustomer?.uid); // 양도/양수 내역
	const transferActivityMutation = useTransferActivity(); // 액티비티 양도하기
	const transferredActivityDecisionMutation = useTransferredActivityDecision(); // 액티비티 양도받기

	const hasTransferableActivity = ownedActivityQuery.data?.data?.filter((v) => v.transferable_count).length > 0; // 양도 가능한 액티비티 유무
	const hasTransferredActivity = transferredActivityListQuery.data?.data?.length > 0; // 양도 받은 액티비티 유무

	const transferForm = useForm();
	// 액티비티 양도 시 횟수 선택 watch
	const watchTransferActivityList = transferForm.watch("transfer_list");

	// 액티비티 양도 거절
	const rejectTransfer = (transferCode) => {
		dispatch(
			showConfirm({
				msg: "액티비티 양도를 거절하시겠습니까?",
				func: () => {
					const payload = {
						event_schedule_idx: scheduleIdx,
						transfer_code: transferCode,
						to_abo_number: primaryCustomer?.uid,
						status: "DECLINED",
					};

					transferredActivityDecisionMutation.mutate(payload, {
						onSuccess: () => {
							dispatch(hideConfirm());
							dispatch(
								showAlert({
									msg: "액티비티 양도를 거절하였습니다.",
									func: () => {
										transferredActivityListQuery.refetch();
										ownedActivityQuery.refetch();
										transferHistoryQuery.refetch();
									},
								})
							);
						},
						onError: (error) => {
							const errorCode = error.response?.data?.code || error.response?.status;
							dispatch(
								showAlert({
									msg: "오류가 발생했습니다. 잠시 후 다시 시도해주세요. \n지속될 경우 담당자에게 문의해주세요. \n Error Code: " + errorCode,
								})
							);
						},
					});
				},
			})
		);
	};

	// 액티비티 양도 받기
	const acceptTransfer = (transferCode) => {
		const payload = {
			event_schedule_idx: scheduleIdx,
			transfer_code: transferCode,
			to_abo_number: primaryCustomer?.uid,
			status: "ACCEPTED",
		};
		transferredActivityDecisionMutation.mutate(payload, {
			onSuccess: () => {
				dispatch(
					showAlert({
						msg: "액티비티를 양도받았습니다.\n액티비티 선택(수정)하기에서 확인하실 수 있습니다.",
						func: () => {
							transferredActivityListQuery.refetch();
							ownedActivityQuery.refetch();
							transferHistoryQuery.refetch();
						},
					})
				);
			},
			onError: (error) => {
				const errorCode = error.response?.data?.code || error.response?.status;
				dispatch(
					showAlert({
						msg: "오류가 발생했습니다. 잠시 후 다시 시도해주세요. \n지속될 경우 담당자에게 문의해주세요. \n Error Code: " + errorCode,
					})
				);
			},
		});
	};

	// 양도할 ABO 인증
	const handleSubmitCheckAbo = () => {
		setIsCheckedAbo((prev) => ({
			...prev,
			status: false,
			msg: "",
		}));
		activityTransferCheckAbo.refetch().then((res) => {
			console.log(res);
			if (res?.status === 'success' && res?.data?.code === 0) {
				setIsCheckedAbo({
					status: true,
					msg: `${maskingUserInfo("abo_number", res.data?.data?.primary_user_name)}님 정보가 정상적으로 확인되었습니다.`,
				});
			} else {
				let msg = res.error?.response?.data?.msg?.ko;
				if (res.error?.response?.data?.code == -19) {
					msg = "등록된 ABO와 일치하는 번호가 없습니다. 다시 입력해 주세요.";
				}
				setIsCheckedAbo({
					status: false,
					msg: msg,
				});
			}
		});
	};

	// 액티비티 양도하기
	const handleSubmitTransfer = () => {
		if (isCheckedAbo.status) {
			const payload = {
				event_schedule_idx: scheduleIdx,
				to_abo_number: checkAbo,
				from_abo_number: primaryCustomer?.uid,
				transfer_list: transferForm.getValues("transfer_list")?.filter((v) => v.transfer_count > 0),
			};

			transferActivityMutation.mutate(payload, {
				onSuccess: () => {
					dispatch(
						showAlert({
							msg: "양도 처리 되었습니다.",
							func: () => {
								setTimeout(() => {
									setShowActivityTransferModal(false);
								}, 350);
								ownedActivityQuery.refetch();
								transferredActivityListQuery.refetch();
								transferHistoryQuery.refetch();
							},
						})
					);
				},
				onError: (error) => {
					const errorCode = error.response?.data?.code || error.response?.status;
					dispatch(
						showAlert({
							msg: "오류가 발생했습니다. 잠시 후 다시 시도해주세요. \n지속될 경우 담당자에게 문의해주세요. \n Error Code: " + errorCode,
						})
					);
				},
			});
		} else {
			dispatch(
				showAlert({
					msg: "양도할 ABO가 인증되지 않았습니다.\n확인 후 시도해주세요.",
				})
			);
		}
	};

	useEffect(() => {
		if (!hasTransferredActivity && showActivityTransferredModal) {
			setTimeout(() => {
				setShowActivityTransferredModal(false);
			}, 350);
		}
	}, [hasTransferredActivity]);

	useEffect(() => {
		if (!showActivityTransferModal) {
			setCheckAbo();
			setIsCheckedAbo((prev) => ({
				...prev,
				status: false,
				msg: "",
			}));
			transferForm.reset();
		}
	}, [showActivityTransferModal]);

	return (
		<Wrap>


			<FormTitle>보유 중인 액티비티 횟수</FormTitle>
			{ownedActivityQuery.data?.data && (
				<>
					<FormTable className="form-table transfer-table-wrap">
						{!isMobile && (
							<>
								<colgroup>
									<col style={{ width: "48%" }} />
								</colgroup>
								<thead>
									<tr>
										<th colSpan={3} className="hide"></th>
									</tr>
								</thead>
							</>
						)}
						<tbody>
							{!isMobile && (
								<tr>
									<th>액티비티명</th>
									<th>양도 가능 횟수</th>
									<th>사용 횟수 / 총 보유 횟수</th>
								</tr>
							)}

							{ownedActivityQuery.data?.data?.map((activity) => {
								if (isMobile) {
									return (
										<tr key={`owned_activity_${activity.activity_idx}`}>
											<td className="p-0">
												<div className="mo-form-table-wrap w-100">
													<FormTable className="form-table">
														<colgroup>
														<col style={{ width: "48%" }} />
													</colgroup>
													<thead>
														<tr>
															<th colSpan={2} className="hide"></th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<th>액티비티명</th>
															<td>{activity.title}</td>
														</tr>
														<tr>
															<th>양도 가능 횟수</th>
															<td>{activity.transferable_count}회</td>
														</tr>
														<tr>
															<th>사용 횟수 / 총 보유 횟수</th>
															<td>
																{activity.applied_count}회 / {activity.total_count}회
															</td>
														</tr>
													</tbody>
												</FormTable>
											</div>
										</td>
									</tr>
								);
								}
								return (
									<tr key={`owned_activity_${activity.activity_idx}`}>
										<td>{activity.title}</td>
										<td>{activity.transferable_count}회</td>
										<td>
											{activity.applied_count}회 / <strong>{activity.total_count}회</strong>
										</td>
									</tr>
								);
							})}
						</tbody>
					</FormTable>
				</>
			)}

			<ul className="notice">
				<li>총 보유 횟수에서 이미 신청한 횟수를 제외한 잔여 횟수만 양도할 수 있습니다.</li>
				<li>양도받은 사람은 이를 거절할 수 있으며, 거절 시 횟수는 다시 복원됩니다.</li>
				<li>양도받은 액티비티는 재양도가 불가능합니다.</li>
				<li>액티비티 양도하기 : 양도 가능한 횟수가 있을 경우 버튼이 활성화됩니다.</li>
				<li>액티비티 양도받기 : 양도받을 액티비티가 있을 경우 버튼이 활성화됩니다.</li>
			</ul>

			<div className="btn-wrap">
				<Button
					disabled={!hasTransferableActivity}
					onClick={() => {
						setShowActivityTransferModal(true);
					}}>
					액티비티 양도하기
				</Button>

				<Button
					$bg="dark"
					disabled={!hasTransferredActivity}
					onClick={() => {
						setShowActivityTransferredModal(true);
					}}>
					액티비티 양도받기
					{hasTransferredActivity && <div className="transfer-tooltip">양도받을 액티비티 횟수가 있어요</div>}
				</Button>
			</div>

			<FormTitle>액티비티 양도/양수 내역​</FormTitle>

			{/* 양도/양수 내역 테이블 */}
			{transferHistoryQuery.data && transferHistoryQuery.data.length > 0 ? (
				<FormTable className="form-table transfer-history-table">
					{!isMobile ? (
						<>
							<thead>
								<tr>
									<th>양도자 (ABO정보)</th>
									<th>양수자 (ABO정보)</th>
									<th>액티비티 명</th>
									<th className="col-count">양도 횟수</th>
									<th className="col-date">양도일시</th>
									<th>상태</th>
								</tr>
							</thead>
							<tbody>
								{transferHistoryQuery.data.map((item) => (
									<React.Fragment key={`desktop_history_${item.transfer_code}`}>
										{item.activity_list.map((activity, aIdx) => (
											<tr key={`${item.transfer_code}-${aIdx}`}>
												{aIdx === 0 && (
													<>
														<td rowSpan={item.activity_list.length}>{item.from_abo_number}({item.from_abo_name})</td>
														<td rowSpan={item.activity_list.length}>{item.to_abo_number}({item.to_abo_name})</td>
													</>
												)}
												<td>{activity.title}</td>
												<td className="col-count">{activity.transfer_count}</td>
												{aIdx === 0 && (
													<>
														<td rowSpan={item.activity_list.length} className="col-date">{item.create_time ? new Date(item.create_time).toLocaleString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).replace(/\. /g, '-').replace('.', '') : '-'}</td>
														<td rowSpan={item.activity_list.length}>{{
															'PENDING': '양도 대기',
															'ACCEPTED': '양도 완료',
															'DECLINED': '거절 (횟수복원)',
															'CANCELED': '양도 취소',
															'EXPIRED': '기한 만료',
															'RETURNED': '양도 반환',
														}[item.status] || item.status}</td>
													</>
												)}
											</tr>
										))}
									</React.Fragment>
								))}
							</tbody>
						</>
					) : (
						/* 모바일: 카드형 */
						<tbody>
							{transferHistoryQuery.data.map((item) => (
								<React.Fragment key={item.transfer_code}>
									<tr><th>양도자 (ABO정보)</th><td>{item.from_abo_number}({item.from_abo_name})</td></tr>
									<tr><th>양수자 (ABO정보)</th><td>{item.to_abo_number}({item.to_abo_name})</td></tr>
									<tr>
										<th>액티비티 명</th>
										<td>
											{item.activity_list.map((activity, idx) => (
												<span key={idx}>
													{activity.title} ({activity.transfer_count}회)
													{idx < item.activity_list.length - 1 && <br />}
												</span>
											))}
										</td>
									</tr>
									<tr><th>양도일시</th><td>{item.create_time ? new Date(item.create_time).toLocaleString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).replace(/\. /g, '-').replace('.', '') : '-'}</td></tr>
									<tr className="status-row"><th>상태</th><td>{{
										'PENDING': '양도 대기',
										'ACCEPTED': '양도 완료',
										'DECLINED': '거절 (횟수복원)',
										'CANCELED': '양도 취소',
										'EXPIRED': '기한 만료',
										'RETURNED': '양도 반환',
									}[item.status] || item.status}</td></tr>
								</React.Fragment>
							))}
						</tbody>
					)}
				</FormTable>
			) : (
				<div className="empty-history">액티비티 양도/양수 내역이 없습니다.</div>
			)}

			<Modal
				show={showActivityTransferModal}
				title="액티비티 양도하기"
				className="activity-transfer-modal"
				hide={() => {
					setShowActivityTransferModal(false);
				}}
				content={
					<>
						<FormTable className="form-table">
							<thead>
								<tr>
									<th>양도할 ABO 확인</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										<div className="abo-input-wrap">
											<div className="form-group">
												<Form.Control
													type="text"
													placeholder="ABO 번호를 입력해 주세요."
													isError={false}
													onInput={(e) => {
														setIsCheckedAbo((prev) => ({
															...prev,
															status: false,
															msg: "",
														}));
														setCheckAbo(e.target.value);
													}}
												/>
												{isCheckedAbo.msg && (
													<div class={isCheckedAbo.status == true ? "form-text mt-1 text-primary" : "form-text mt-1 text-danger"}>
														{isCheckedAbo.status ? "✓" : "✗"} {isCheckedAbo.msg}
													</div>
												)}
											</div>
											<Button type="button" className="btn-check-abo" $bg="dark" disabled={!checkAbo || activityTransferCheckAbo.isFetching} onClick={handleSubmitCheckAbo}>
												확인하기
											</Button>
										</div>
									</td>
								</tr>
							</tbody>
						</FormTable>

						<FormTable className="form-table transfer-table-wrap">
							{!isMobile && (
								<>
									<colgroup>
										<col style={{ width: "49%" }} />
										<col style={{ width: "30%" }} />
									</colgroup>
									<thead>
										<tr>
											<th colSpan={3}>액티비티별 양도할 횟수 설정</th>
										</tr>
									</thead>
								</>
							)}
							<tbody>
								{!isMobile && (
									<tr>
										<th>액티비티명</th>
										<th>양도할 횟수</th>
										<th>양도 가능 횟수</th>
									</tr>
								)}
								{ownedActivityQuery.data?.data?.map((activity, activityIdx) => {
									const transferableCount = activity.transferable_count > -1 ? activity.transferable_count : 0;
									if (isMobile) {
										return (
											<tr key={`owned_activity_${activity.activity_idx}`}>
												<td className="p-0">
													<div className="mo-form-table-wrap w-100">
														<FormTable className="form-table">
															{activityIdx === 0 && (
																<thead>
																	<tr>
																		<th colSpan={2}>액티비티별 양도할 횟수 설정</th>
																	</tr>
																</thead>
															)}
															<tbody>
																<tr>
																	<th>액티비티명</th>
																	<td>{activity.title}</td>
																</tr>
																<tr>
																	<th>양도 할 횟수</th>
																	<td>
																		<input
																			type="hidden"
																			{...transferForm.register(`transfer_list.${activityIdx}.activity_idx`, {
																				value: activity.activity_idx,
																			})}
																		/>
																		<input
																			type="hidden"
																			{...transferForm.register(`transfer_list.${activityIdx}.activity_schedule_idx`, {
																				value: activity.activity_schedule_idx,
																			})}
																		/>
																		<Controller
																			control={transferForm.control}
																			name={`transfer_list.${activityIdx}.transfer_count`}
																			defaultValue={transferableCount === 0 ? 0 : undefined}
																			rules={{
																				required: true,
																			}}
																			render={({ field }) => {
																				return (
																					<SelectOption
																						placeholder={"선택"}
																						disabled={transferableCount === 0}
																						data={Array(transferableCount + 1)
																							.fill(0)
																							.map((el, idx) => {
																								return {
																									idx: idx,
																									label: idx,
																									value: idx,
																								};
																							})}
																						value={field.value}
																						ref={field.ref}
																						onChange={(e) => {
																							field.onChange(e);
																						}}
																					/>
																				);
																			}}
																		/>
																	</td>
																</tr>
																<tr>
																	<th>양도 가능 횟수</th>
																	<td>{transferableCount}회</td>
																</tr>
															</tbody>
														</FormTable>
													</div>
												</td>
											</tr>
										);
									}
									return (
										<tr key={`transferable_count_${activity.activity_idx}`}>
											<td>{activity.title}</td>
											<td style={{ paddingRight: "40px" }}>
												<input
													type="hidden"
													{...transferForm.register(`transfer_list.${activityIdx}.activity_idx`, {
														value: activity.activity_idx,
													})}
												/>
												<input
													type="hidden"
													{...transferForm.register(`transfer_list.${activityIdx}.activity_schedule_idx`, {
														value: activity.activity_schedule_idx,
													})}
												/>
												<Controller
													control={transferForm.control}
													name={`transfer_list.${activityIdx}.transfer_count`}
													rules={{
														required: true,
													}}
													defaultValue={transferableCount === 0 ? 0 : undefined}
													render={({ field }) => {
														return (
															<SelectOption
																placeholder={"선택"}
																disabled={transferableCount === 0}
																data={Array(transferableCount + 1)
																	.fill(0)
																	.map((el, idx) => {
																		return {
																			idx: idx,
																			label: idx,
																			value: idx,
																		};
																	})}
																value={field.value}
																ref={field.ref}
																onChange={(e) => {
																	field.onChange(e);
																}}
															/>
														);
													}}
												/>
											</td>
											<td>{transferableCount}회</td>
										</tr>
									);
								})}
							</tbody>
						</FormTable>

						<div className="btn-wrap">
							<Button
								onClick={() => {
									setShowActivityTransferModal(false);
								}}>
								취소
							</Button>
							<Button $bg="dark" className="btn-transfer" disabled={!transferForm.formState.isValid || watchTransferActivityList?.filter((v) => v.transfer_count > 0).length == 0 || transferActivityMutation.isPending} onClick={handleSubmitTransfer}>
								양도하기
							</Button>
						</div>
					</>
				}
			/>

			<Modal
				show={showActivityTransferredModal}
				title="액티비티 양도받기"
				className="activity-transferred-modal"
				hide={() => {
					setShowActivityTransferredModal(false);
				}}
				content={
					<>
						<FormTable className="form-table transfer-table-wrap">
							{!isMobile && (
								<>
									<colgroup>
										<col style={{ width: "13%" }} />
										<col style={{ width: "14%" }} />
										<col style={{ width: "23%" }} />
										<col style={{ width: "12%" }} />
										<col style={{ width: "18%" }} />
									</colgroup>
									<thead>
										<tr>
											<th colSpan={6}>양도 받은 액티비티 정보</th>
										</tr>
									</thead>
								</>
							)}
							<tbody>
								{/* header */}
								{!isMobile && (
									<tr>
										<th>ABO 번호</th>
										<th>이름</th>
										<th>액티비티명</th>
										<th>양도 받은 횟수</th>
										<th style={{ textAlign: "center" }}>양도 거절</th>
										<th style={{ textAlign: "center" }}>양도 완료</th>
									</tr>
								)}

								{/* body */}
								{/* 한 사람 당 양도 받은 액티비티가 2개 이상일 경우 rowspan 처리 */}
								{transferredActivityListQuery.data?.data?.map((transfer, transferIdx) => {
									if (isMobile) {
										return (
											<tr key={`transferred_${transfer.transfer_code}`}>
												<td className="p-0">
													<div className="mo-form-table-wrap w-100">
														<FormTable className="form-table">
															<colgroup>
															<col style={{ width: "40%" }} />
														</colgroup>
														{transferIdx === 0 && (
															<thead>
																<tr>
																	<th colSpan={2}>양도 받은 액티비티 정보</th>
																</tr>
															</thead>
														)}
														<tbody>
															<tr>
																<td colSpan={2} className="activity-info">
																	<ul>
																		<li>
																			<div className="title">ABO 번호</div>
																			<div className="value">{transfer.from_abo_number}</div>
																		</li>
																		<li>
																			<div className="title">이름</div>
																			<div className="value">{transfer.from_abo_name}</div>
																		</li>
																	</ul>
																</td>
															</tr>
															{transfer.activity_list?.map((activity) => {
																return (
																	<tr key={`activity_${activity.transfer_idx}_${activity.activity_idx}`}>
																		{/* 
																			한 사람 당 양도 받은 액티비티가 2개 이상일 경우 
																		*/}
																		<td colSpan={2} className="activity-info">
																			<ul>
																				<li>
																					<div className="title">액티비티명</div>
																					<div className="value">{activity.title}</div>
																				</li>

																				<li>
																					<div className="title">양도 받은 횟수</div>
																					<div className="value">{activity.transfer_count}회</div>
																				</li>
																			</ul>
																		</td>
																	</tr>
																);
															})}

															<tr>
																<td colSpan={2}>
																	<div className="btn-wrap">
																		<Button $bg="light" $color="dark" className="btn-reject" onClick={() => rejectTransfer(transfer.transfer_code)}>
																			거절하기
																		</Button>
																		<Button $bg="dark" className="btn-accept" onClick={() => acceptTransfer(transfer.transfer_code)}>
																			양도 받기
																		</Button>
																	</div>
																</td>
															</tr>
														</tbody>
													</FormTable>
												</div>
											</td>
										</tr>
									);
								}
								return (
									<React.Fragment key={`transferredGroup_${transfer.transfer_code}`}>
										{transfer.activity_list?.map((activity, activityIdx) => {
											return (
												<tr key={`transferredActivity_${transferIdx}_${activityIdx}_${transfer.transfer_code}`}>
													{activityIdx === 0 && (
														<>
															<td rowSpan={transfer.activity_list.length}>{transfer.from_abo_number}</td>
															<td rowSpan={transfer.activity_list.length}>{transfer.from_abo_name}</td>
														</>
													)}
													<td>{activity.title}</td>
													<td>{activity.transfer_count}</td>
													{activityIdx === 0 && (
														<>
															<td style={{ textAlign: "center" }} rowSpan={transfer.activity_list.length}>
																<Button $bg="light" $color="dark" className="btn-reject" onClick={() => rejectTransfer(transfer.transfer_code)}>
																	거절하기
																</Button>
															</td>
															<td style={{ textAlign: "center" }} rowSpan={transfer.activity_list.length}>
																<Button $bg="dark" className="btn-accept" onClick={() => acceptTransfer(transfer.transfer_code)}>
																	양도 받기
																</Button>
															</td>
														</>
													)}
												</tr>
											);
										})}
									</React.Fragment>
								);
							})}
							</tbody>
						</FormTable>

						<Caption className="caption">양도 받은 횟수는 ‘액티비티 선택(수정)하기’에서 사용 가능 합니다.</Caption>
					</>
				}
			/>
		</Wrap>
	);
};

export default ActivityTransfer;
